<template>
	<td
		v-if="header.condition ? header.condition() : true"
		:class="header.valueType === ValueType.Percentage ? 'align-end' : ''"
	>
		<div class="table-cell-wrap">
			<div class="table-cell-flex">
				<span class="column-value">{{ displayValue }}</span>
			</div>
		</div>
	</td>
</template>

<script setup lang="ts" generic="T">
import { ValueType } from "@/enums/ValueType";
import { formatNumericPercentage } from "@/helpers/inputHelpers";
import type { AppCardTableHeaderModel } from "@/models/AppCardTableHeaderModel";
import { computed } from "vue";

const props = defineProps<{
	header: AppCardTableHeaderModel<T>;
	value?: string | number;
}>();

const displayValue = computed(() => {
	let value: string | number | undefined;

	if (props.header.valueType === ValueType.Percentage) {
		value = `${formatNumericPercentage(props.value) ?? props.header.default} %`;
	} else {
		value = props.value;
	}

	return value ?? props.header.default;
});
</script>

<style lang="scss">
td.align-end {
	text-align: right;

	.table-cell-flex {
		align-items: flex-end;
	}
}
</style>
